import { FieldNameToControlBaseValueConverter } from 'General/Resources/ValueConverters/FieldNameToControlBase';
export class FieldNameToControlValueConverter extends FieldNameToControlBaseValueConverter {

}